import { render, staticRenderFns } from "./CreatePreCharge.vue?vue&type=template&id=6b648562&"
import script from "./CreatePreCharge.vue?vue&type=script&lang=js&"
export * from "./CreatePreCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports